module.exports = __webpack_public_path__ + "img/close_icon.021a8ec9.svg";